import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto font-mono text-5xl mb-10" }
const _hoisted_2 = { class: "text-left pt-10 pb-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-dDollar" }, "$ ", -1)
const _hoisted_4 = { class: "text-dOM" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { class: "border-gray-500" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1)
    ]),
    _hoisted_5
  ]))
}